<panel width="510" [refresh]="dataProvider.refreshService">
  <h1>{{ 'company.sites' | translate }}</h1>

  @if (loading) {
    <skeletons [defaultSkeletons]="3" />
  }

  @if (!loading) {
    <section scrollable>
      @if (webProductPlans.length == 0) {
        <text-group>{{ 'company-sites.no-active-website-product-plans' | translate }}</text-group>
      }
      @for (site of sites; track getSiteId($index, site)) {
        @if (!site.replacesSite && !site.$new) {
          <card span-columns [attr.disabled]="site.$deleted">
            <website-details [site]="site" [productPlan]="siteProductPlan(site)" />
          </card>
        }
      }
    </section>
  }
  <add-company-site [companyId]="companyId" *requiredCredential="CredentialType.ManageCompanySites; and: webProductPlans.length > 0"></add-company-site>
</panel>
